// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-image[data-v-12f2e7cd]{aspect-ratio:1/1;-o-object-fit:cover;object-fit:cover}@media (min-width: 1024px){.modal-image[data-v-12f2e7cd]{aspect-ratio:3/5}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
